import PropTypes from 'prop-types';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';

function PageBlueHeader({ title, subtitle, subtitleNoWrap = false }) {
  return (
    <ArgonBox pt={2} pb={0} sx={{ position: 'relative', zIndex: 1 }}>
      <ArgonTypography
        variant="h3"
        fontWeight="bold"
        color="white"
        sx={{
          fontSize: { xs: '1.45rem', sm: '1.75rem' },
          letterSpacing: '-0.02em',
          lineHeight: 1.2,
        }}
      >
        {title}
      </ArgonTypography>
      {subtitle ? (
        <ArgonTypography
          variant="body2"
          color="white"
          sx={{
            opacity: 0.82,
            mt: 1,
            lineHeight: 1.55,
            fontSize: '0.925rem',
            ...(subtitleNoWrap ? { whiteSpace: 'nowrap' } : {}),
          }}
        >
          {subtitle}
        </ArgonTypography>
      ) : null}
    </ArgonBox>
  );
}

PageBlueHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  subtitleNoWrap: PropTypes.bool,
};

export default PageBlueHeader;
